import React from 'react'
import SentCardListContainer from '../SentCardListContainer.jsx'
import { useSelector } from 'react-redux'

function SentList({ title }) {
    const { user } = useSelector((state) => state.user);

    return (
        <SentCardListContainer user={user} matches={user.likes} title={title} />
    )
}

export default SentList